<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3">{{selectServerTitle}}</div>
      <div class="setting-addel mr-l15">
        <el-button size="mini" icon="fas fa-check-square" @click="checkAllList(true)"></el-button>
        <el-button size="mini" icon="fas fa-square" @click="checkAllList(false)"></el-button>
      </div>
    </div>
    <div>
      <el-button size="small" type="primary" :disabled="!modified" @click="saveCheckList">저장</el-button>
      <el-button size="small" :disabled="!modified" @click="cancelCheckList">취소</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper v-loading="loading" ref="settingList" slot="body" :data="dataList" :columns="occupyColumns" :pagination="true" :show-custom-header="true" :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote :show-search-tool="showSearchTool"
    style="width:100%;">
    <template slot-scope="scope" slot="authStatus">
        <el-checkbox v-model="scope.row.checkFlag" :true-label="1" :false-label="0" @change="checkMajorSettingChange"></el-checkbox>
      </template>
  </el-table-wrapper>
</div>
</template>

<script>
import { columnDefault } from '@/constants/table';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import { isNil, differenceWith, isEqual } from 'lodash';
import { isTrue } from '@/utils/boolean';
import msgUtil from '@/utils/message';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WMajorPortSettingList',
  components: {},
  props: {
    selectPhysicalNode: Object,
  },
  data() {
    return {
      total: null,
      columnDefault,
      modified: false,
      dataList: [],
      originalData: [],
      showSearchTool: false,
      selectServerTitle: '',
      loading: false,
      params: {
        serverId: null,
      },
      occupyColumns: [
        {
          width: 90,
          scopedSlot: 'authStatus',
          label: '선택',
          sortable: true,
        },
        {
          prop: 'netPortnum',
          width: 90,
          label: '포트번호',
          remoteProp: 'net_portnum',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'serviceName',
          label: '포트명',
          remoteProp: 'service_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode)) {
          this.params.serverId = this.selectPhysicalNode.serverId;
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      if (Object.keys(this.selectPhysicalNode).indexOf('obj') > 0) {
        const tableParams = this.$refs.settingList.getParameter();
        const params = {
          ...this.params,
          ...tableParams,
        };
        this.loading = true;
        ServerSettingAPI.getServicePortList(params)
          .then((response) => {
            if (response.data.success) {
              this.selectServerTitle = `[${this.selectPhysicalNode.label}] 서비스 포트 설정`;
              this.dataList = response.data.data;
              this.total = response.data.total;
              this.modified = false;
              this.originalData = cloneDeep(response.data.data);
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '서비스 포트 설정', false));
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '서비스 포트 설정', false));
            throw new Error(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    /**
     * [checkAllList 버튼 선택시 allCheckFlag에 따라 checkBox를 true/false 설정]
     * @author yelim
     * @param  {[type]} allCheckFlag [description]
     * @return {[type]}              [description]
     */
    checkAllList(value) {
      if (!isNil(this.dataList) && this.dataList.length > 0) {
        forEach(this.dataList, (item) => {
          item.checkFlag = value;
        });
        this.checkMajorSettingChange();
      }
    },
    /**
     * 서비스 포트 설정 변경 여부를 체크한다.
     * @author Ju
     * @return {[type]} [description]
     */
    checkMajorSettingChange() {
      const limit = this.dataList.length;
      let modified = false;
      for (let i = 0; i < limit; i += 1) {
        if (isTrue(this.dataList[i].checkFlag) !== isTrue(this.originalData[i].checkFlag)) {
          modified = true;
          break;
        }
      }
      this.modified = modified;
    },
    /**
     * [saveCheckList 초기에 불러온 데이터와 체크된 데이터를 비교하여 변한 데이터만 저장한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    saveCheckList() {
      const diffList = this.getModifiedDatas();
      const target = '포트 정보';
      const action = msgUtil.action.SAVE;
      ServerSettingAPI.updateServicePortList(diffList)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    /**
     * 변경된 데이터를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getModifiedDatas() {
      const modifiedDatas = [];
      forEach(this.dataList, (item, index) => {
        if (isTrue(item.checkFlag) !== isTrue(this.originalData[index].checkFlag)) {
          modifiedDatas.push(item);
        }
      });
      return modifiedDatas;
    },
    cancelCheckList() {
      this.dataList = this.originalData;
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onChangeTable() {
      this.loadData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/PortSettings/MajorPortSettingView/component/MajorPortSettingList.vue